@if (initialized) {
  <div class="content">
    <form [formGroup]="inputForm">
      <div class="container">
        <!-- Bid Item section -->
        <section>
          @if (smt.bid_item) {
            <div class="link" (click)="openBidItemSelector()">
              <div class="mat-headline-5">{{smt.bid_item?.item}}</div>
              <div class="mat-body">{{smt.bid_item?.description}}</div>
            </div>
          }
          @if (!smt.bid_item) {
            <div class="input-placeholder" (click)="openBidItemSelector()">
              <button mat-icon-button [disabled]="!editing" color="accent">
                <mat-icon>add</mat-icon>
              </button>Add bid item
            </div>
          }
          <input style="display: none;" formControlName="bid_item_id" />
          @if (formSubmitted && inputForm.controls.bid_item_id.hasError('required')) {
            <mat-error>
              This field is <strong>required</strong>
            </mat-error>
          }
          @if (formSubmitted && inputForm.controls.bid_item_id.hasError('error')) {
            <mat-error>
              {{inputForm.controls.bid_item_id.errors.error}}
            </mat-error>
          }
        </section>
        <!-- /Bid Item section -->
        <!-- Test Name -->
        <section>
          <div class="mat-body-2 row">Test name:</div>
          @if (!editing) {
            <div class="mat-body capitalize">{{smt.material_test?.name}}</div>
          }
          @if (editing) {
            <mat-form-field>
              <mat-label>Test name</mat-label>
              <mat-select formControlName="material_test_id" [errorStateMatcher]="matcher">
                @for (test of materialTests; track test) {
                  <mat-option [value]="test.id">
                    <div>{{test.name}}</div>
                  </mat-option>
                }
              </mat-select>
              @if (inputForm.controls.material_test_id.hasError('required')) {
                <mat-error>
                  This field is <strong>required</strong>
                </mat-error>
              }
              @if (inputForm.controls.material_test_id.hasError('error')) {
                <mat-error>
                  {{inputForm.controls.material_test_id.errors.error}}
                </mat-error>
              }
            </mat-form-field>
          }
        </section>
        <!-- /Test Name -->
        <!-- Lab -->
        <section>
          <div class="mat-body-2 row">Lab name:</div>
          @if (!editing) {
            <div class="mat-body capitalize">{{smt.lab?.name}}</div>
          }
          @if (editing) {
            <mat-form-field>
              <mat-label>Select lab</mat-label>
              <mat-select formControlName="lab_id" [errorStateMatcher]="matcher">
                @for (lab of labs; track lab) {
                  <mat-option [value]="lab.id">
                    <div>{{lab.name}}</div>
                  </mat-option>
                }
              </mat-select>
              @if (inputForm.controls.lab_id.hasError('required')) {
                <mat-error>
                  This field is <strong>required</strong>
                </mat-error>
              }
              @if (inputForm.controls.lab_id.hasError('error')) {
                <mat-error>
                  {{inputForm.controls.lab_id.errors.error}}
                </mat-error>
              }
            </mat-form-field>
          }
        </section>
        <!-- /Lab -->
        <!-- Request Date -->
        <section>
          <div class="mat-body-2">Date &amp; Time:</div>
          @if (!editing) {
            <div class="mat-body">
              {{smt.request_date | dateFormat: 'long'}} {{smt.request_date | dateDurationFormat: smt.request_interval}}
            </div>
          }
          @if (editing) {
            <div class="row">
              <mat-form-field>
                <mat-label>Choose a date</mat-label>
                <input matInput [matDatepicker]="requestDatePicker" formControlName="request_date"
                  [errorStateMatcher]="matcher" autocomplete="off">
                <mat-datepicker-toggle matSuffix [for]="requestDatePicker"></mat-datepicker-toggle>
                <mat-datepicker #requestDatePicker [calendarHeaderComponent]="calendarHeader"></mat-datepicker>
                @if (inputForm.controls.request_date.hasError('required')) {
                  <mat-error>
                    This field is <strong>required</strong>
                  </mat-error>
                }
                @if (inputForm.controls.request_date.hasError('error')) {
                  <mat-error>
                    {{inputForm.controls.request_date.errors.error}}
                  </mat-error>
                }
              </mat-form-field>
            </div>
          }
          @if (editing) {
            <div class="row">
              <mat-form-field>
                <mat-label>From time</mat-label>
                <input matInput autocomplete="off" [ngxTimepicker]="fromPicker" [format]="24" formControlName="from_time"
                  [errorStateMatcher]="matcher" />
                <ngx-material-timepicker #fromPicker></ngx-material-timepicker>
                @if (inputForm.controls.from_time.hasError('required')) {
                  <mat-error>
                    This field is <strong>required</strong>
                  </mat-error>
                }
              </mat-form-field>
              <mat-form-field>
                <mat-label>To time</mat-label>
                <input matInput autocomplete="off" [ngxTimepicker]="toPicker" [format]="24" formControlName="to_time"
                  [errorStateMatcher]="matcher" />
                <ngx-material-timepicker #toPicker></ngx-material-timepicker>
                @if (inputForm.controls.to_time.hasError('required')) {
                  <mat-error>
                    This field is <strong>required</strong>
                  </mat-error>
                }
              </mat-form-field>
            </div>
          }
        </section>
        <!-- /Request Date -->
        <!-- Annotation section -->
        <!--        <section>-->
        <!--          <div class="mat-subheading-1">Annotation:</div>-->
        <!--          <div class="input-placeholder" *ngIf="!smt.annotation">-->
        <!--            <button mat-icon-button [disabled]="!editing" color="accent" (click)="openAnnot()">-->
        <!--              <mat-icon>add</mat-icon>-->
      <!--            </button>Add annotation-->
    <!--          </div>-->
    <!--          <div class="preview-list">-->
    <!--            <div *ngIf="smt.annotation">-->
    <!--              <img class="link" [src]="smt.annotation.getThumbnail()" alt="Annotation Preview"-->
    <!--                (click)="openAnnot(smt.annotation)" />-->
    <!--              <button *ngIf="editing" class="hover-icon" mat-icon-button aria-label="Delete" title="Delete"-->
    <!--                (click)="removeAnnot(smt.annotation)">-->
    <!--                <mat-icon>delete</mat-icon>-->
  <!--              </button>-->
<!--            </div>-->
<!--          </div>-->
<!--        </section>-->
<!-- /Annotation section -->
<!-- location section -->
<section>
  <div class="mat-body-2">Location:</div>
  @if (!smt.latitude || !smt.longitude) {
    <div class="input-placeholder" (click)="editLocation(issue)">
      <button mat-icon-button [disabled]="!editing" color="accent">
        <mat-icon>location_on</mat-icon>
      </button>Add Location
    </div>
  }
  @if (smt.latitude) {
    <div (click)="editLocation(smt)">
      <app-location-picker [isDialog]="false" [latitude]="smt.latitude" [longitude]="smt.longitude" height="100px"
      [readOnly]="true"></app-location-picker>
    </div>
  }
</section>
<!-- /location section -->
<!-- Pictures section -->
<section>
  <div class="mat-body-2">Pictures:</div>
  <div class="preview-list">
    <app-file-uploader class="file-uploader input-placeholder small"
      [disabled]="!editing" icon="image" accept="image/*"
      (complete)="onUploadComplete($event)">
    </app-file-uploader>
    @for (pic of smt.pictures; track pic) {
      <div>
        <img [src]="pic.getThumbnail()" class="link" (click)="appSrv.openCarousel($event, smt.pictures, pic)" />
        @if (editing) {
          <button mat-icon-button aria-label="Delete" title="Delete" class="hover-icon"
            (click)="removePicture(pic)">
            <mat-icon>delete</mat-icon>
          </button>
        }
      </div>
    }
  </div>
</section>
<!-- /Pictures section -->
<!-- Comment section -->
<section>
  <div class="mat-body-2">Comment:</div>
  @if (!editing) {
    <div class="mat-body">{{smt.comment}}</div>
  }
  @if (editing) {
    <mat-form-field>
      <textarea matInput formControlName="comment" [errorStateMatcher]="matcher"></textarea>
      @if (inputForm.controls.comment.hasError('required')) {
        <mat-error>
          This field is <strong>required</strong>
        </mat-error>
      }
      @if (inputForm.controls.comment.hasError('error')) {
        <mat-error>
          {{inputForm.controls.comment.errors.error}}
        </mat-error>
      }
    </mat-form-field>
  }
</section>
<!-- /Comment section -->
<!-- Form Actions -->
<section>
  @if (editing && (smt.status === 'draft' || !smt.status)) {
    <div class="row">
      <button mat-stroked-button color="primary" (click)="saveItem()">
        @if (smt.id) {
          Update &amp; send
        }
        @if (!smt.id) {
          Create &amp; send
        }
      </button>
    </div>
  }
</section>
<!-- Form Actions -->
</div>
</form>
</div>
}
